<template>
  <pl-dialog
    :title="'Import from which course?'"
    :size="'md'"
    :disableOutsideClick="true"
    @close="closeModal"
  >
    <body class="center items-center p-5 flex-grow">
      <div class="p-4">
        <span>
          This will import all of the saved feedback templates from the course
          you select. Any edits you make will not be reflected in the old
          course, so you can change or delete any imported templates.
        </span>
      </div>
      <div
        v-if="courses.length"
        class="row no-margin pt3 center-xs courses-list"
      >
        <ul>
          <li
            v-for="(course, index) in courses"
            :key="course.id"
            @click="selectCourse(index)"
            class="flex flex-nowrap items-center w-100"
          >
            <div>
              <pl-checkbox
                v-model="selectedCourses"
                :value="course"
                @change="selectedCourses()"
                class=""
              />
            </div>
            <div>
              <label :for="course.title" :title="course.title">
                {{ course.title | truncate(26) }}
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div v-else class="row no-margin pv3 center-xs f4 b">
        No saved feedback to import
      </div>
    </body>
    <footer class="flex my-5 center items-center">
      <button
        class="mx-5 px-10 py-2 w-40 hover:bg-gray-200 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold disabled:opacity-50"
        @click="closeModal"
      >
        Cancel
      </button>
      <button
        class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
        :disabled="!selectedCourses.length"
        @click="importFeedback"
      >
        Import
      </button>
    </footer>
  </pl-dialog>
</template>

<script lang="babel">
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  import courseDetailsService from 'services/courses';

  export default {
    data() {
      return {
        selectedCourses: [],
        selected_index: null,
        courses: []
      };
    },
    props: {
      onlineRT: {
        type: Boolean,
        default() {
          return false;
        }
      },
    },
    computed: {
      ...mapGetters([
        'getCourses',
        'getCourseDetail',
      ]),
    },
    watch: {
      selectedCourses: function (selectedCourses) {
        return selectedCourses;
      },
    },
    methods: {
      closeModal() {
        this.$emit('modalFeedbackClosed');
      },
      selectCourse(index) {
        this.selected_index = index;
      },
      getListCoursesWithFeedback(){
        const feedback_type = this.onlineRT ? 'online' : 'live';

        courseDetailsService.showCoursesWithFeedback(this.getCourseDetail.id, feedback_type).then((courses)=>{
            this.courses=courses.data;
        });
      },
      importFeedback() {
        if(this.onlineRT) {
          const courses = this.selectedCourses.map(c => c.id);
          this.$store.dispatch('importFeedbackOnline', {
            course_id: this.getCourseDetail.id,
            courses
          })
          .then(EventBus.$emit('toast-msg', 'Success, feedback(s) has been imported.'))
          .catch(console.error);
        } else {
          const courses = this.selectedCourses.map(c => c.id);
          this.$store.dispatch('importFeedbackLive', {
            course_id: this.getCourseDetail.id,
            courses
          })
          .then(EventBus.$emit('toast-msg', 'Success, feedback(s) has been imported.'))
          .catch(console.error);
        }
        this.$emit('modalFeedbackClosed');
      },
    },
    mounted(){
      this.getListCoursesWithFeedback();
    }
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .sub-header-title{
    font-size: 12px;
    color: pl-slate;
  }

  .courses-list{
    height: 300px;
    overflow: auto;
    &&::-webkit-scrollbar {
      display: unset !important;
      width: unset !important;
    }
  }

  ul {
    list-style-type: none; /* Remove bullets */
    padding: 0; /* Remove padding */
    margin: 0; /* Remove margins */
    width: inherit;
  }

  li {
    padding: 0px 10px 0px 20px;
  }
</style>



// WEBPACK FOOTER //
// importSavedFeedbackModal.vue?268e36ce